export const joinNonEmptyItems = (array: string[]): string => {
  return array.filter((word) => !!word).join(", ");
};
